import { render, staticRenderFns } from "./PropertyCheckinPointHistoryForCheckin.vue?vue&type=template&id=a222607e&"
import script from "./PropertyCheckinPointHistoryForCheckin.vue?vue&type=script&lang=js&"
export * from "./PropertyCheckinPointHistoryForCheckin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VDataTable,VIcon})
